// aos js
AOS.init({
  duration: 1200,
});
// mobile version
AOS.init({disable: 'mobile'});
	AOS.init({
	disable: function() {
	  var maxWidth = 991;
	  return window.innerWidth < maxWidth;
	}
});


// banner slider js

$('#banner-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-angle-up"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-angle-down"></i></button>',
  //infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});


// services slider js
$('#services-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  //infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev'><i class='fa-solid fa-angle-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next'><i class='fa-solid fa-angle-right'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});




// testmonials slider js
$('#testmonials-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  //infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow:"<button type='button' class='slick-prev'><i class='fa-solid fa-angle-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next'><i class='fa-solid fa-angle-right'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});


// blog slider js
$('#blog-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  //infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow:"<button type='button' class='slick-prev'><i class='fa-solid fa-angle-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next'><i class='fa-solid fa-angle-right'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});




$(document).ready(function () {
    $('.btnNext').click(function (e) {
        e.preventDefault();
        $(this).closest('fieldset').slideUp().next().slideDown()
    });
    $('.btnPrev').click(function (e) {
        e.preventDefault();
        $(this).closest('fieldset').slideUp().prev().slideDown()
    })
});






var counted = 0;
  $(window).load(function() {
  
    var oTop = $('#counter').offset().top - window.innerHeight;
    if (counted == 0) {
      $('.count').each(function() {
        var $this = $(this),
          countTo = $this.attr('data-count');
        $({
          countNum: $this.text()
        }).animate({
            countNum: countTo
          },
  
          {
  
            duration: 5000,
            easing: 'swing',
            step: function() {
              $this.text(Math.floor(this.countNum));
            },
            complete: function() {
              $this.text(this.countNum);
              //alert('finished');
            }
  
          });
      });
      counted = 1;
    }
  
  });
  
  
  
  
  
  
  $('#brand-slider').owlCarousel({
    loop:true,
    // center: true,
    margin:150,
    nav:false,
    navText: ["<i class='fa fa-chevron-left' aria-hidden='true'></i>","<i class='fa fa-chevron-right' aria-hidden='true'></i>"],
    dots:false,
    autoplay:true,
    autoplayTimeout:1000,
    autoplayHoverPause:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:6
        }
    }
  })
  
  
  
$('#about-slider').owlCarousel({
    loop:true,
    // center: true,
    margin:10,
    nav:false,
    navText: ["<i class='fa fa-chevron-left' aria-hidden='true'></i>","<i class='fa fa-chevron-right' aria-hidden='true'></i>"],
    dots:false,
    autoplay:true,
    autoplayTimeout:1000,
    autoplayHoverPause:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
  })
  
  
  
  
  
  $(document).ready(function () {
  $('.navbar .menu-item-has-children').hover(function () {
          $(this).find('.sub-menu').first().stop(true, true).slideDown(100);
      }, function () {
          $(this).find('.sub-menu').first().stop(true, true).slideUp(200)
      });
  });
  
  
  
  
  
  
  $(window).scroll(function(){
  if ($(window).scrollTop() >= 300) {
      $('.navbar-light').addClass('fixed-header');
  }
  else {
      $('.navbar-light').removeClass('fixed-header');
  }
});